export default from './create-post-button';



// WEBPACK FOOTER //
// ./app/components/create-post-button/index.js